/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React, {useMemo} from 'react'
import styles from './AdBox.module.scss'
import {ColonistMembershipType, ModeSettingEnum} from '@colonist/types'
import {type AjaxDataTypes} from '../../../../../../../code/shared/AjaxDataTypes.ts'
import {
    AnalyticEventCategory,
    AnalyticEventType,
    AnalyticEventValue,
} from '../../../../../../../code/shared/entity_datas/EntityDatas.ts'
import {CA} from '../../../../../../../code/client/shared/scripts/analytics/Analytics.ts'
import {T, useUIGlobalContext, useUserStateContext} from '@colonist/ui'
import {AD_BOX_CONTENT} from '../../constants.ts'
import {navigateToPage} from '../../../../../../../code/client/shared/scripts/ui_utils/ClientUtils.ts'
import {UIUrlParameterNames} from '../../../../../../../code/client/shared/scripts/ui_html/UIUrlController.ts'
import {UIEntryUrlParameterController} from '../../../../../../../code/client/shared/scripts/UIEntryUrlParameterController.ts'
import {uiManagerEvents} from '../../../../../../../code/client/shared/scripts/EntryShared.ts'
import {useGameStore} from '../../../../store/GameStoreContext.ts'
import {useIsReplay} from '../../../../store/selectors/useIsReplay.ts'

export interface AdBoxProps {
    className?: string
}

export const AdBox = ({
    className,
}: AdBoxProps) => {
    const isReplay = useIsReplay()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const {isUserOnDiscord} = useUIGlobalContext()
    const {hasFoundersPack, membershipType, hasMembership} = useUserStateContext()

    const shouldShowEndGameItemBox = useMemo(() => {
        const isBeginnerMode = modeSetting == ModeSettingEnum.BeginnerModeClassic4P
        if(isReplay || isBeginnerMode) return false

        if(hasFoundersPack) return false
        switch(membershipType) {
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                return false
            default:
                return true
        }
    }, [modeSetting, isReplay, hasFoundersPack, membershipType])

    const adBoxContent = useMemo(() => {
        const allContent = AD_BOX_CONTENT

        if(hasMembership) {
            const contentWithoutAds = allContent.filter((content) => !content.isRemoveAdContent)
            return contentWithoutAds
        }

        return allContent
    }, [hasMembership])

    const onClickAdBox = () => {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.ItemBoxMembershipEndgame,
        }
        void CA.sendAnalyticEvent(eventData)
        if(isUserOnDiscord) {
            uiManagerEvents.handleUrlRedirectViaParameters(UIUrlParameterNames.DiscordStore, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE)
            return
        }
        navigateToPage('/store#membership', true)
    }
    const randomIndex = useMemo(() => Math.floor(Math.random() * adBoxContent.length), [adBoxContent])

    if(!shouldShowEndGameItemBox) return null

    return <div className={clsx(styles.container, className)}>
        <div className={styles.imageContainer}>
            <img
                className={styles.image}
                onClick={onClickAdBox}
                src={adBoxContent[randomIndex].image} />
        </div>
        <div className={styles.text}>
            <T id={adBoxContent[randomIndex].title}/>
        </div>
    </div>
}
